import React from 'react';
import { IdentityBlock, DateChip, timeGapChipText } from './ExploreComparisonCard';

// ExploreTeaserCard — dimmed preview of the NEXT card in the deck.
// Hidden when the deck is exhausted (page renders nothing).
//
// variant="desktop": identity block + date chip strip at opacity 0.45
//                    (design-recreation desktop "next card teaser").
// variant="mobile":  meta row + "{GAP} / GLOWUP" headline + masked
//                    before/after strip fading out (mobile teaser).
const ExploreTeaserCard = ({ card, variant = 'desktop', className = '' }) => {
  if (!card) return null;

  if (variant === 'mobile') {
    const gapLabel = card.time_gap_label || '';
    return (
      <div className={`opacity-70 ${className}`.trim()} aria-hidden="true">
        <p className="font-display text-[#B8B2A6] m-0" style={{ fontSize: 15 }}>
          {gapLabel ? `Anonymous · ${gapLabel.toLowerCase()} glowup` : 'Anonymous glowup'}
        </p>
        <div className="mt-3">
          {gapLabel && (
            <div
              className="font-display uppercase tracking-[0.22em] text-[#D8D2C6]"
              style={{ fontSize: 13 }}
            >
              {gapLabel}
            </div>
          )}
          <div
            className="font-display text-bone tracking-[0.06em]"
            style={{ fontSize: 38, lineHeight: 1.1 }}
          >
            GLOWUP
          </div>
        </div>
        <div
          className="grid grid-cols-2 gap-0.5 mt-3.5 rounded-t-field overflow-hidden h-24"
          style={{
            WebkitMaskImage: 'linear-gradient(180deg, #000 30%, transparent)',
            maskImage: 'linear-gradient(180deg, #000 30%, transparent)',
          }}
        >
          <img
            src={card.before && card.before.anonymized_image_url}
            alt=""
            className="w-full h-24 object-cover block"
            style={{ objectPosition: 'center 22%' }}
          />
          <img
            src={card.after && card.after.anonymized_image_url}
            alt=""
            className="w-full h-24 object-cover block"
            style={{ objectPosition: 'center 22%' }}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={[
        'bg-[#161615] border border-hairline-soft rounded-card px-6 py-5',
        'opacity-45 flex justify-between items-center gap-4',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      <IdentityBlock />
      <DateChip>{timeGapChipText(card)}</DateChip>
    </div>
  );
};

export default ExploreTeaserCard;
